// Angular
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';

@Component({
	selector: 'kt-bom-import-result',
	templateUrl: './bom-import-result.component.html',
	styleUrls: ["../bom.component.scss"],
})
export class BOMImportResultComponent implements OnInit {
	viewLoading: boolean = false;
	res = {};
	CONFIG: CommonConFig;
	constructor(public dialogRef: MatDialogRef<BOMImportResultComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	ngOnInit() {
		this.CONFIG = new CommonConFig();
		this.res = this.data;
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	onYesClick(): void {
		this.viewLoading = true;
		setTimeout(() => {this.dialogRef.close(true);}, 0);
	}
}
